module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dianne Drake\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Approaching 50 Harlequin titles, Dianne is still as passionate about writing romance as ever. As a former intensive care nurse, it's no wonder medicine has found its way into her writing, and she's grateful to "), _c('B', [_vm._v("Harlequin Medicals")]), _vm._v(" for allowing her to write her stories"), _c('B', [_vm._v(".")]), _vm._v(" "), _c('I', [_vm._v("\"They return me")]), _c('I', [_vm._v(" to the days I loved being a nurse and combine that with my love of the romance novels I've been reading since I was a young teen.\"")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16FsoWf/tc-custom/9781460335611.jpg?1702677883778",
      "alt": "This image is the cover for the book Doctor's Confession, Deep South Docs"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Doctor's Confession, Deep South Docs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A secret shared")]), _c('br'), _c('br'), _vm._v("After tragically losing a patient, former doctor Alain Lalonde has come to the bayou in America's Deep South to forget his past. But he can't resist helping people, and he's drawn to intriguingly beautiful nurse Maggie Doucet!"), _c('br'), _c('br'), _vm._v("Maggie doesn't have time for men. Not even gorgeous, muscled carpenters like Alain. But when a difficult case unexpectedly makes them foster parents, they find themselves not only bonding with the childbut with each other, too!"), _c('br'), _c('br'), _c('i', [_vm._v("Has Alain found a woman he can trust with his dark secret?")]), _c('br'), _c('br'), _c('b', [_vm._v("Deep South Docs!")]), _c('br'), _c('i', [_vm._v("Swapping the big cityfor the bayou!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0